const getAppDomain = (): string =>
  window.location?.hostname?.includes('localhost') ? '' : '.openbankpay.com';

export { getAppDomain };
